// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: atdcK1hSZxqWg32TQQ3iWK
// Component: WBul9F6qbiKH
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "../blank_website_mobile_first/plasmic_blank_website_mobile_first.module.css"; // plasmic-import: atdcK1hSZxqWg32TQQ3iWK/projectcss
import sty from "./PlasmicRedLink.module.css"; // plasmic-import: WBul9F6qbiKH/css

createPlasmicElementProxy;

export const PlasmicRedLink__VariantProps = new Array();

export const PlasmicRedLink__ArgProps = new Array("to", "text");

const $$ = {};

function PlasmicRedLink__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          to: "https://www.suomengolfseniorit.fi/yhteystiedot",
          text: "Some text"
        },
        props.args
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  return (
    <a
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.__wab_text,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      href={args.to}
      target={"_blank"}
    >
      <React.Fragment>
        {(() => {
          try {
            return $props.text;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return "https://www.suomengolfseniorit.fi/yhteystiedot";
            }
            throw e;
          }
        })()}
      </React.Fragment>
    </a>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRedLink__ArgProps,
          internalVariantPropNames: PlasmicRedLink__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRedLink__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRedLink";
  } else {
    func.displayName = `PlasmicRedLink.${nodeName}`;
  }
  return func;
}

export const PlasmicRedLink = Object.assign(
  // Top-level PlasmicRedLink renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicRedLink
    internalVariantProps: PlasmicRedLink__VariantProps,
    internalArgProps: PlasmicRedLink__ArgProps
  }
);

export default PlasmicRedLink;
/* prettier-ignore-end */
